import { Component, OnInit,Inject } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { QueryVhweb, OrdinaryComponent } from 'private-angular-vhframeworks';
import { FormGroup, FormControl, Validators } from '@angular/forms';
export interface DialogData {
  animal: string;
  pname: string;
}
@Component({
  selector: 'app-receive-contact',
  templateUrl: './receive-contact.component.html',
  styleUrls: ['./receive-contact.component.scss']
})
export class ReceiveContactComponent implements OnInit {

  form:FormGroup;
  constructor(
    public dialogRef: MatDialogRef<ReceiveContactComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private queryVhweb: QueryVhweb,
    private ordinaryComponent: OrdinaryComponent,
  ) {
    this.initForm();
  }

  ngOnInit(): void {
    if (window.screen.width < 500) {
      {
        this.dialogRef.updateSize('95%', 'auto')
      }
    }
  }
  close(){
    this.dialogRef.close();
  }
  onNoClick(): void {
    this.dialogRef.close();
  }

  initForm() {
    this.form = new FormGroup({
      name: new FormControl('', [Validators.required]),
      email: new FormControl('', [Validators.required, Validators.email]),
      phone: new FormControl('', [Validators.required]),
      content: new FormControl('', [Validators.required]),
      product: new FormControl(this.data.pname),
      date: new FormControl(new Date())
    })

  }


  send(){
    this.form.controls['phone'].setValue(this.form.value.phone.toString())
    this.queryVhweb.createProduct('receive-contact', this.form.value)
      .then(result => {
        if (result.created) {
          this.ordinaryComponent.showToast(1500, "Đã gửi thành công")
          this.onNoClick()
          this.form.reset();
          // this.onNoClick();
        }
        else {
          alert('Có lỗi xảy ra vui lòng thử lại')
        }
      }).catch(err => { console.log(err) })
  }


}
